import { ClientProfileRelationshipType } from '@/types/schema';

export const GRANTOR_RELATIONSHIP_COPY_MAP: Partial<
  Record<ClientProfileRelationshipType, string>
> = {
  [ClientProfileRelationshipType.Child]: 'Child',
  [ClientProfileRelationshipType.StepChild]: 'Stepchild',
  [ClientProfileRelationshipType.DomesticPartner]: 'Domestic partner',
  [ClientProfileRelationshipType.ExDomesticPartner]: 'Ex-domestic partner',
  [ClientProfileRelationshipType.Friend]: 'Friend',
  [ClientProfileRelationshipType.Grandchild]: 'Grandchild',
  [ClientProfileRelationshipType.Grandparent]: 'Grandparent',
  [ClientProfileRelationshipType.Parent]: 'Parent',
  [ClientProfileRelationshipType.StepParent]: 'Stepparent',
  [ClientProfileRelationshipType.UncleAunt]: 'Uncle/Aunt',
  [ClientProfileRelationshipType.NephewNiece]: 'Nephew/Niece',
  [ClientProfileRelationshipType.Cousin]: 'Cousin',
  [ClientProfileRelationshipType.Sibling]: 'Sibling',
  [ClientProfileRelationshipType.Spouse]: 'Spouse',
  [ClientProfileRelationshipType.ExSpouse]: 'Ex-spouse',
  [ClientProfileRelationshipType.OtherRelative]: 'Other relative',
  [ClientProfileRelationshipType.OtherNonRelative]: 'Other non-relative',
};

export const PRIMARY_CLIENT_RELATIONSHIP_COPY_MAP: Partial<
  Record<ClientProfileRelationshipType, string>
> = {
  ...GRANTOR_RELATIONSHIP_COPY_MAP,
  [ClientProfileRelationshipType.OtherNonRelative]: 'Other',
};

export const GRANTOR_RELATIONSHIP_ITEMS = [
  ClientProfileRelationshipType.Child,
  ClientProfileRelationshipType.StepChild,
  ClientProfileRelationshipType.DomesticPartner,
  ClientProfileRelationshipType.Friend,
  ClientProfileRelationshipType.Grandchild,
  ClientProfileRelationshipType.Grandparent,
  ClientProfileRelationshipType.Parent,
  ClientProfileRelationshipType.Sibling,
  ClientProfileRelationshipType.Spouse,
  ClientProfileRelationshipType.ExSpouse,
  ClientProfileRelationshipType.OtherRelative,
  ClientProfileRelationshipType.OtherNonRelative,
  ClientProfileRelationshipType.UncleAunt,
  ClientProfileRelationshipType.NephewNiece,
  ClientProfileRelationshipType.Cousin,
];

/** These are the relationships that primary clients can have with each other */
export const PRIMARY_CLIENT_RELATIONSHIP_ITEMS = [
  ClientProfileRelationshipType.Spouse,
  ClientProfileRelationshipType.DomesticPartner,
  ClientProfileRelationshipType.ExSpouse,
  ClientProfileRelationshipType.OtherNonRelative,
];
